import React from "react";
import FiltersDrawer, { FilterField, FilterSection } from "../../common/FiltersDrawer";
import MultiSelectFilter from "../../common/MultiSelectFilter";
import RequestedByFilter from "../../common/RequestedByFilter";
import FilterSelect from "../../common/FilterSelect";
import useGlobalAppAndLanguage from "../../../hooks/useGlobalAppAndLanguage";
import useCtmCategories from "../../../hooks/useCtmCategories";
import { PRIORITIES_FILTER_OPTIONS, QC_FILTER_OPTIONS } from "../../../utils/constants/index";
import { EMPTY_PANEL_FILTERS } from "../../../utils/constants/AdRequest";
import { SOURCE_FILTER_OPTIONS } from "../../../utils/constants/listFilters";
import useFilterDraft from "../../../hooks/useFilterDraft";

/** Filters drawer for the Ad Request list; edits a draft and applies it on Apply. */
const RequestFiltersPanel = ({ applied, onApply, count, showAgencyFilter, agencyOptions, defaultAgencyId }) => {
  const { open, draft, setDraft, onOpenChange, apply } = useFilterDraft(applied, onApply);
  const { globalApp, globalLanguage } = useGlobalAppAndLanguage();
  const categories = useCtmCategories(
    { app: globalApp, language: globalLanguage },
    { enabled: open }
  );
  const categoryOptions = categories.map((c) => ({ value: c, label: c }));

  const setField = (key) => (value) => setDraft((d) => ({ ...d, [key]: value }));

  return (
    <FiltersDrawer
      count={count}
      open={open}
      onOpenChange={onOpenChange}
      onApply={apply}
      onReset={() => setDraft(EMPTY_PANEL_FILTERS)}
    >
      <FilterSection title="Content">
        <FilterField label="Category" wide>
          <MultiSelectFilter
            value={draft.categories}
            onChange={setField("categories")}
            options={categoryOptions}
            placeholder="All categories"
          />
        </FilterField>
      </FilterSection>
      <FilterSection title="Status">
        <FilterField label="Priority">
          <FilterSelect
            value={draft.priority}
            allLabel="All priority"
            placeholder="Priority"
            options={PRIORITIES_FILTER_OPTIONS}
            onChange={setField("priority")}
            width="w-full"
            className="w-full"
          />
        </FilterField>
        <FilterField label="QC status">
          <FilterSelect
            value={draft.qcStatus}
            allLabel="All QC statuses"
            placeholder="QC status"
            options={QC_FILTER_OPTIONS}
            onChange={setField("qcStatus")}
            width="w-full"
            className="w-full"
          />
        </FilterField>
        <FilterField label="Source" wide>
          <FilterSelect
            value={draft.source}
            allLabel="All sources"
            placeholder="Source"
            options={SOURCE_FILTER_OPTIONS}
            onChange={setField("source")}
            width="w-full"
            className="w-full"
          />
        </FilterField>
      </FilterSection>
      <FilterSection title="People">
        {showAgencyFilter && (
          <FilterField label="Agency" wide>
            <FilterSelect
              value={draft.agency}
              allLabel="All agencies"
              placeholder="Agency"
              options={agencyOptions}
              onChange={setField("agency")}
              width="w-full"
              className="w-full"
            />
          </FilterField>
        )}
        <FilterField label="Requested by" wide>
          <RequestedByFilter
            value={draft.requestedBy}
            onChange={(ids, labels) => setDraft((d) => ({ ...d, requestedBy: ids, requestedByLabels: labels || [] }))}
            multiple
            agencyId={draft.agency ? Number(draft.agency) : defaultAgencyId ?? undefined}
            placeholder="Anyone"
            fullWidth
          />
        </FilterField>
      </FilterSection>
    </FiltersDrawer>
  );
};

export default RequestFiltersPanel;
